import React from 'react';

/* React Confirm Alert */
import { ioteraConfirmAlert } from '../../lib/components/react/react-confirm-alert';

import ReactLoading from 'react-loading';

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { actions as notificationActions } from '../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit, AppLink, S } from '../../routes/routes'

/* Object Json */
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';
import { isNone } from 'iotera-base/object';
import { isTextEmpty } from 'iotera-base/text';

import { SizeMe } from 'react-sizeme';
import IoteraClass from '../../lib/components/react/react-class';
import Skeleton from '@material-ui/lab/Skeleton';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

import User from '../../assets/user.png';

const INIT_USERS = 'INIT_USERS';
const INIT_ROLES = "INIT_ROLES";
const DELETE = 'DELETE';
const RELOAD = 'RELOAD';
const WKEY = 'USER_LIST';
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

class UsersCard extends IoteraClass {
  constructor(props) {
    super(props);
    this.onDelete = this.onDelete.bind(this);
    this.handleEmpty = this.handleEmpty.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleDelete(id) {
    this.props.wSingleRequestCall({
      id: DELETE,
      body: {
        id
      }
    })
  };

  handleEmpty() {
    this.props.showSingleNotification({
      message: 'Tidak dapat menambah pengguna, belum ada role terdaftar',
      position: 'tr', level: 'error'
    });
  }

  onDelete(id) {
    ioteraConfirmAlert(
      null,
      'Apakah anda yakin ingin menghapus pengguna ini?',
      'Ya, hapus',
      () => this.handleDelete(id),
      null,
      null
    )
  }

  onKelola(id) {
    const _props = this.props
    ioteraConfirmAlert(
      'Kelola Pengguna',
      'Apa yang ingin anda kelola?',
      'Info',
      () => _props.history.push(`./_user_edit_/${id}`),
      'Password',
      () => _props.history.push(`./@user/password/${id}`),
    )
  }

  gotoPath = (id) => {
    ioteraConfirmAlert(
      'Kelola Pengguna',
      'Apa yang ingin anda lakukan dengan pengguna ini?',
      'Kelola',
      () => this.onKelola(id),
      'Hapus',
      () => this.onDelete(id)
    )
  }

  render() {
    const _this = this;
    const _props = _this.props
    let showSkeleton = safeDeepGetWithType(_props, ['show'], false)
    let userCards = []
    let roles = safeDeepGet(_props, ['access'], []);
    let currWidth = safeDeepGetWithType(_props, ['displaySize', 'width'], 0);
    let customCol = currWidth <= 996 ? "io-col-md-6" : "io-col-md-3"
    let data = safeDeepGet(_props, ['data'])
    if (!isNone(data)) {
      data.forEach((user, index) => {
        let name;
        if (isTextEmpty(user.last)) {
          name = user.first;
        } else {
          name = user.first + ' ' + user.last;
        }
        let role = '\u00A0';
        if (!isTextEmpty(user.role_id)) {
          for (let i = 0; i < roles.length; i++) {
            if (user.role_id === roles[i].id) {
              role = roles[i].name;
            }
          }
        }
        userCards.push(
          <div key={index} className={customCol} onClick={() => _this.gotoPath(user.id)}>
            <div className="io-card io-card__shadow-sm io-card__direct" style={{ height: '200px' }}>
              <div className="card-body card-body__compact text-center ">
                <div className="io-row align-items-center h-100">
                  <div className="io-col">
                    <div className="embed-responsive embed-responsive-1by1 mx-auto mb-4" style={{ width: '56px' }}>
                      <div className="embed-responsive-item p-3 bg-light rounded-circle">
                        <img src={User}
                          alt="avatar" className="image__contain" />
                      </div>
                    </div>
                    <h6 className="mb-2 font-weight-normal io-text-primary" style={{
                      textDecoration: 'none',
                      fontStyle: 'italic'
                    }}>{user.username}</h6>
                    <h6 className="mb-2 font-weight-normal" style={{ textDecoration: 'none' }}>{name}</h6>
                    <h5 className="font-weight-normal text-gray-300 mb-0" style={{ textDecoration: 'none' }}>
                      {role}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      });
    }
    return (
      <div className="io-container mt-12">
        <div className="io-row align-items-center mb-4">
          <div className="io-col">
            <h3 className="mt-4 font-weight-normal">List of User</h3>
            <h6 className="text-gray-300 font-weight-normal">Manage user</h6>
          </div>
          <div className="io-col-auto">
            {roles.length > 0 ? <AppLink  {..._props} to={'_user_add_'} >
              <div className="io-btn io-btn-primary">
                Create User
              </div>
            </AppLink> :
              <div className="io-btn io-btn-primary" onClick={(e) => _this.handleEmpty()}>
                Create User
              </div>
            }
          </div>
        </div>
        <div className='io-row' style={{ margin: '0 -5px' }}>
          {showSkeleton ?
            <div className={customCol} style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 10 }}>
              <Skeleton variant="rect" width={'100%'} height={200} />
            </div>
            :
            userCards
          }
        </div>
      </div>
    )
  }
}

class Users extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        requests: {
          [INIT_USERS]: {
            wparam: { ...domainIsTenant, path: "/service/web/application/account/manage/list" },
            wcallback: {
              started: function (id) {
                // TODO Loading
              },
              finished: function (id, result) {
                // TODO Loading
              }
            }
          },
          [INIT_ROLES]: {
            wparam: { ...domainIsTenant, path: "/service/web/application/account/role/list" },
            wcallback: {
              started: function (id) {
                // TODO Loading
              },
              finished: function (id, result) {
                // TODO Loading
                _this.setState({
                  loading: false
                })
              }
            }
          }
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [DELETE]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/account/manage/remove"
          },
          wcallback: {
            started: function (id) {
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false
                  })
                  _this.props.showSingleNotification({ message: 'Hapus User Sukses', level: 'success' });
                  _props.wSingleRequestCall({
                    id: RELOAD,
                  })
                  return;
                }
              }
              _props.showSingleNotification({ message: 'Hapus User Gagal', position: 'tr', level: 'error' });
            }
          }
        },
        [RELOAD]: {
          wparam: { ...domainIsTenant, path: "/service/web/application/nav/list" },
          wcallback: {
            started: function (id) {
              // TODO Loading
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              // TODO Loading
              const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
              if (responseResult === Result.SUCCESS) {
                _this.setState({
                  loading: false,
                  navs: safeDeepGetWithType(result, ['body', 'navs'], _props.items)
                })
                return;
              }
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    let { loading } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    return (
      <div  >
        <SizeMe>{({ size }) =>
          <UsersCard {..._props} data={_props.items} displaySize={size} show={loading} />
        }
        </SizeMe>
      </div >
    )
  }
}

const mapStateToProps = function (state, props) {
  return {
    items: wSelector.getMappedRPayload(state, INIT_USERS, 'accounts'),
    access: wSelector.getMappedRPayload(state, INIT_ROLES, 'roles')
  }
};

const mapDispatchToProps = (dispatch) => ({
  ...wBoundActions(dispatch),
  ...bindActionCreators(notificationActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Users);